var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLike(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.916 2L6.25 7.333H2V18h12.561c.94 0 1.76-.664 1.958-1.583l1.437-6.667c.263-1.232-.7-2.417-1.958-2.417h-5.187c.05-.416.06-.836.375-1.791.204-.618.146-1.185.146-1.542 0-.497-.2-.956-.541-1.333A1.975 1.975 0 009.332 2h-.416zm.75 1.5c.041.031.11.02.146.063A.739.739 0 019.999 4c0 .432.013.836-.083 1.125-.498 1.508-.584 2.833-.584 2.833l-.041.709h6.707c.44 0 .737.382.646.812l-1.416 6.667a.671.671 0 01-.667.52H7.333v-8.5L9.666 3.5zM3.333 8.667H6v8H3.333v-8zm1.333 6a.668.668 0 000 1.333.668.668 0 000-1.333z",
    fill: "currentColor",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLike);
export default __webpack_public_path__ + "static/media/like.cf5b53deaa74049cbbc53fab18811fdb.svg";
export { ForwardRef as ReactComponent };